import { ToolName } from '../types.js';
import { createCreditorMessageTool } from './create-creditor-message.js';
import { createInteractionTool } from './create-interaction.js';
import { createPaymentPlanTool } from './create-payment-plan.js';
import { createUpdateTool } from './create-update.js';
import { endCaseTool } from './end-case.js';
import { escalateToHumanTool } from './escalate-to-human.js';
import { getCreditorTool } from './get-creditor.js';
import { getCurrentPaymentPlanTool } from './get-current-payment-plan.js';
import { getCustomerTool } from './get-customer.js';
import { getDocumentTool } from './get-document.js';
import { getFileTool } from './get-file.js';
import { getInteractionTool } from './get-interaction.js';
import { getPaymentPlanTool } from './get-payment-plan.js';
import { getTemplateTool } from './get-template.js';
import { getToolTool } from './get-tool.js';
import { getTribunalCaseTool } from './get-tribunal-case.js';
import { getUpdateTypeTool } from './get-update-type.js';
import { getUpdateTool } from './get-update.js';
import { getVoucherTool } from './get-voucher.js';
import { getWorkflowTool } from './get-workflow.js';
import { listPendingProposalsTool } from './list-pending-proposals.js';
import { reportOutcomeTool } from './report-outcome.js';
import { searchCaseHistoryTool } from './search-case-history.js';
import { searchContactPersonsTool } from './search-contact-persons.js';
import { searchDocumentsTool } from './search-documents.js';
import { searchInteractionsTool } from './search-interactions.js';
import { searchMentionsTool } from './search-mentions.js';
import { searchPaymentPlansTool } from './search-payment-plans.js';
import { searchPropertiesTool } from './search-properties.js';
import { searchTemplatesTool } from './search-templates.js';
import { searchToolsTool } from './search-tools.js';
import { searchTribunalCasesTool } from './search-tribunal-cases.js';
import { searchUpdateTypesTool } from './search-update-types.js';
import { searchUpdatesTool } from './search-updates.js';
import { searchVouchersTool } from './search-vouchers.js';
// `satisfies` (not an explicit annotation) so each entry keeps its specific
// ToolDefinition<I, O> instead of widening to ToolDefinition<unknown>.
export const toolRegistry = {
    [ToolName.SearchTools]: searchToolsTool,
    [ToolName.GetTool]: getToolTool,
    [ToolName.ListPendingProposals]: listPendingProposalsTool,
    [ToolName.EscalateToHuman]: escalateToHumanTool,
    [ToolName.ReportOutcome]: reportOutcomeTool,
    [ToolName.GetCustomer]: getCustomerTool,
    [ToolName.GetCreditor]: getCreditorTool,
    [ToolName.GetWorkflow]: getWorkflowTool,
    [ToolName.GetCurrentPaymentPlan]: getCurrentPaymentPlanTool,
    [ToolName.SearchCaseHistory]: searchCaseHistoryTool,
    [ToolName.SearchContactPersons]: searchContactPersonsTool,
    [ToolName.SearchProperties]: searchPropertiesTool,
    [ToolName.SearchInteractions]: searchInteractionsTool,
    [ToolName.GetInteraction]: getInteractionTool,
    [ToolName.SearchVouchers]: searchVouchersTool,
    [ToolName.GetVoucher]: getVoucherTool,
    [ToolName.SearchTemplates]: searchTemplatesTool,
    [ToolName.GetTemplate]: getTemplateTool,
    [ToolName.SearchMentions]: searchMentionsTool,
    [ToolName.SearchUpdateTypes]: searchUpdateTypesTool,
    [ToolName.GetUpdateType]: getUpdateTypeTool,
    [ToolName.SearchUpdates]: searchUpdatesTool,
    [ToolName.GetUpdate]: getUpdateTool,
    [ToolName.SearchDocuments]: searchDocumentsTool,
    [ToolName.GetDocument]: getDocumentTool,
    [ToolName.GetFile]: getFileTool,
    [ToolName.SearchPaymentPlans]: searchPaymentPlansTool,
    [ToolName.GetPaymentPlan]: getPaymentPlanTool,
    [ToolName.SearchTribunalCases]: searchTribunalCasesTool,
    [ToolName.GetTribunalCase]: getTribunalCaseTool,
    [ToolName.CreateInteraction]: createInteractionTool,
    [ToolName.CreateCreditorMessage]: createCreditorMessageTool,
    [ToolName.CreatePaymentPlan]: createPaymentPlanTool,
    [ToolName.CreateUpdate]: createUpdateTool,
    [ToolName.EndCase]: endCaseTool,
};
export const allTools = Object.values(toolRegistry);
export const initiallyVisibleTools = [
    ToolName.SearchTools,
    ToolName.GetTool,
    ToolName.ListPendingProposals,
    ToolName.EscalateToHuman,
    ToolName.ReportOutcome,
    ToolName.SearchCaseHistory,
    ToolName.SearchUpdates,
    ToolName.GetCustomer,
    ToolName.GetCurrentPaymentPlan,
    ToolName.SearchInteractions,
    ToolName.SearchVouchers,
    ToolName.CreateInteraction,
    ToolName.CreateCreditorMessage,
    ToolName.CreatePaymentPlan,
    ToolName.CreateUpdate,
    ToolName.EndCase,
];
export const temporarilyDisabledTools = new Set([
    ToolName.EndCase,
]);
export const toolsByCategory = (category) => allTools.filter((t) => t.category === category);
export const getTool = (name) => toolRegistry[name];
//# sourceMappingURL=index.js.map